import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { usePageContent } from "../../../i18n/useContentMap";

import HeaderPageTitle from "../../../layouts/inc/HeaderPageTitle";

const MemberList = () => {
  const content = usePageContent("member"); // Get member page translations
  // const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateProfile = useSelector((state) => state.profile);

  /* Handle goto page */
  const navigate = useNavigate();

  const handleGotoPage = (e) => {
    e.preventDefault();
    // console.log("click GotoPage", e.currentTarget.dataset.page);

    const page = e.currentTarget.dataset.page;
    navigate("/" + page);
  };
  /* End Handle goto page */

  /* First event render */
  const [memberPointAll, setMemberPointAll] = useState([]);

  useEffect(() => {
    // console.log("useEffect !", stateProfile);

    if (Object.getOwnPropertyNames(stateProfile.dataUser).length === 0) {
      navigate("/");
    } else {
      if (typeof stateProfile.dataUser.memberPoint !== "undefined" && typeof stateProfile.dataUser.memberPoint["all"] !== "undefined") {
        setMemberPointAll(stateProfile.dataUser.memberPoint["all"]);
      }
    }
  }, []);
  /* End First event render */

  // useEffect(() => {
  //   console.log(memberPointAll);
  // }, [memberPointAll]);

  return (
    <>
      <Helmet>
        <title>{content.title || "Paypoint"}</title>
        <meta name="title" content={content.title || "Paypoint"} />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content={content.title || "Paypoint"} />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pagePoint">
        <main>
          <div className="wrapContent">
            <HeaderPageTitle title={content.myPoints} prevPage="/member" />

            <section id="pMembercardMain">
              <div className="bMembercard">
                <div className="titleProfile">
                  <div className="bUserDetail">
                    <div className="bDtail">
                      <div className="bImg">
                        <img src={stateProfile.lineImgUrl} alt="" />
                      </div>
                      <div className="tName">
                        <p>{content.welcome}</p>
                        <p>{stateProfile.dataUser.fullname}</p>
                      </div>
                    </div>
                    <div className="bBtn">
                      <a href="#" onClick={handleGotoPage} data-page="profile">
                        {content.viewProfile}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="pMemberPoint">
              <div className="bTitle">
                <h2>{content.memberList}</h2>
                <p>{content.pointsDescription}</p>
              </div>
              <div className="bMemberList">
                {/* <?php for ($y = 1; $y <= 4; $y++) {?> */}
                {/* <article>
                  <div className="bLeft">
                    <div className="bPic">
                      <img
                        src="https://dummyimage.com/200x200/667085/fff"
                        alt=""
                      />
                    </div>
                    <div className="bName">
                      <h3>Member Name</h3>
                      <p>ST12345678</p>
                    </div>
                  </div>
                  <div className="bPoint">
                    <p>
                      <span>9,999,999</span>
                      พอยท์
                    </p>
                  </div>
                </article> */}
                {/* <?php };?> */}
                {memberPointAll.length > 0 ? (
                  memberPointAll.map((val, idx) => (
                    <article>
                      <div className="bLeft">
                        <div className="bPic">
                          <img src={val.imageFileUrl} alt="" />
                        </div>
                        <div className="bName">
                          <h3>{val.name}</h3>
                          <p>{val.memberId}</p>
                        </div>
                      </div>
                      <div className="bPoint">
                        <p>
                          <span>{parseInt(val.point).toLocaleString()}</span>
                          {content.points}
                        </p>
                      </div>
                    </article>
                  ))
                ) : (
                  <></>
                )}
              </div>
            </section>
          </div>
        </main>
      </div>
    </>
  );
};

export default MemberList;
